// Triple-bar divider motif — the site's pan-flag signature. Three short stripes
// in magenta / gold / sky, stacked side-by-side. Shows up under headings,
// inside the nav, in the footer, under the hero — anywhere a quiet "three
// colors, together" moment would ground the palette.

export default function PanBar({
  width = 96,
  height = 4,
  gap = 3,
  align = "center",   // "left" | "center" | "right"
  margin = "0.9rem auto",
  style,
}) {
  const segW = (width - gap * 2) / 3;
  const justify = align === "left" ? "flex-start" : align === "right" ? "flex-end" : "center";
  return (
    <div
      aria-hidden="true"
      style={{
        display: "flex",
        gap: `${gap}px`,
        justifyContent: justify,
        margin,
        ...style,
      }}
    >
      <span style={{ width: segW, height, background: "var(--jop-pink)",           borderRadius: height / 2, boxShadow: "0 0 12px rgba(239,83,126,0.45)" }} />
      <span style={{ width: segW, height, background: "var(--jop-gold)",           borderRadius: height / 2, boxShadow: "0 0 12px rgba(252,179,31,0.45)" }} />
      <span style={{ width: segW, height, background: "var(--jop-highlight-blue)", borderRadius: height / 2, boxShadow: "0 0 12px rgba(74,164,225,0.45)" }} />
    </div>
  );
}
